export type PanelState = {
    state: "none" | "images" | "resources" | "inspirations" | "summary" | "steps"
    loading: boolean;
};

export const initState: PanelState = {
    state: "none",
    loading: false,
};
